import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../button/button.module';
import { HeaderModule } from '../header/header.module';
import { HomeComponent } from './home.component';

@NgModule({
  declarations: [HomeComponent],
  imports: [CommonModule, HeaderModule, ButtonModule],
  exports: [HomeComponent],
})
export class HomeModule {}
